export default "__VITE_ASSET__BY7dcRpK__"